/**
 * Region Border Data
 * Auto-generated by scripts/downloadBorders.ts
 * Last updated: 2025-12-28T04:19:02.780Z
 */

import { RegionCode } from "../../types";

// Import individual border files
import iranBorder from "./iran.json";
import iraqBorder from "./iraq.json";
import syriaBorder from "./syria.json";
import afghanistanBorder from "./afghanistan.json";
import turkeyBorder from "./turkey.json";
import pakistanBorder from "./pakistan.json";
import armeniaBorder from "./armenia.json";
import azerbaijanBorder from "./azerbaijan.json";
import turkmenistanBorder from "./turkmenistan.json";

export interface BorderFeature {
  type: "Feature";
  properties: {
    code: string;
    name: string;
    iso_a3: string;
    originalName?: string;
  };
  geometry: {
    type: "Polygon" | "MultiPolygon";
    coordinates: number[][][] | number[][][][];
  };
}

// Export all borders
export const REGION_BORDERS: Partial<Record<RegionCode, BorderFeature>> = {
  iran: iranBorder as BorderFeature,
  iraq: iraqBorder as BorderFeature,
  syria: syriaBorder as BorderFeature,
  afghanistan: afghanistanBorder as BorderFeature,
  turkey: turkeyBorder as BorderFeature,
  pakistan: pakistanBorder as BorderFeature,
  armenia: armeniaBorder as BorderFeature,
  azerbaijan: azerbaijanBorder as BorderFeature,
  turkmenistan: turkmenistanBorder as BorderFeature,
};

// Helper to get border for a region
export function getRegionBorder(regionCode: RegionCode): BorderFeature | null {
  return REGION_BORDERS[regionCode] || null;
}

// Helper to convert border coordinates to Mapbox format [lng, lat]
export function getBorderCoordinatesForMapbox(regionCode: RegionCode): number[][][] | null {
  const border = getRegionBorder(regionCode);
  if (!border) return null;
  
  if (border.geometry.type === "Polygon") {
    return border.geometry.coordinates as number[][][];
  } else if (border.geometry.type === "MultiPolygon") {
    // For MultiPolygon, return the first (main) polygon
    return (border.geometry.coordinates as number[][][][])[0];
  }
  
  return null;
}
